const TECHNISCHE_FEHLER = /(?:SQLSTATE|PDOException|Fatal error|Uncaught|Stack trace|Call Stack|(?:[a-z]:\\|\/(?:var\/www|home|srv|opt)\/)| on line \d+)/i;

export function sichereApiFehlermeldung(text, fallback) {
  const meldung = typeof text === 'string' ? text.trim() : '';
  if (!meldung || TECHNISCHE_FEHLER.test(meldung) || /<[^>]+>/.test(meldung)) {
    return fallback;
  }
  return meldung;
}

function jsonAusAntwort(xhr) {
  if (xhr && xhr.responseJSON && typeof xhr.responseJSON === 'object') {
    return xhr.responseJSON;
  }
  if (!xhr || typeof xhr.responseText !== 'string') {
    return null;
  }
  const antwort = xhr.responseText.trim();
  if (!antwort || (antwort[0] !== '{' && antwort[0] !== '[')) {
    return null;
  }
  try {
    return JSON.parse(antwort);
  } catch {
    return null;
  }
}

export function apiFehlermeldung(xhr, textStatus, fallback) {
  const antwort = jsonAusAntwort(xhr);
  if (antwort && typeof antwort === 'object') {
    const meldung = sichereApiFehlermeldung(antwort.message, '');
    if (meldung) {
      return meldung;
    }
  }

  const status = xhr && Number(xhr.status);
  if (status === 0 || textStatus === 'timeout') {
    return 'Die Serverantwort ist ausgeblieben. Bitte die Ansicht neu laden und zuerst prüfen, ob das Dokument dennoch gespeichert wurde, bevor Sie den Vorgang wiederholen.';
  }
  if (status === 401 || status === 403) {
    return 'Die Sitzung ist abgelaufen oder die Berechtigung fehlt. Bitte neu anmelden.';
  }
  if (status === 409) {
    return 'Das Dokument konnte wegen eines Konflikts nicht gespeichert werden. Bitte die Angaben prüfen und erneut versuchen.';
  }
  if (status === 413) {
    return 'Die ausgewählte Datei ist zu groß.';
  }
  if (status === 422) {
    return 'Die übermittelten Dokumentdaten konnten nicht verarbeitet werden. Bitte die Angaben prüfen.';
  }
  if (textStatus === 'parsererror') {
    return 'Der Server hat keine gültige Antwort geliefert. Bitte die Ansicht neu laden und zuerst prüfen, ob das Dokument dennoch gespeichert wurde, bevor Sie den Vorgang wiederholen.';
  }
  if (status >= 500) {
    return 'Beim Verarbeiten des Dokuments ist ein interner Serverfehler aufgetreten. Bitte die Ansicht neu laden und prüfen, ob es dennoch gespeichert wurde, bevor Sie es später erneut versuchen.';
  }
  return fallback;
}
